<template>
<div class="container" id="main">

  <div class="card text-center">
    <div class="card-body">
      <h5 class="card-title">Welcome {{$store.state.name}}</h5>
      <p class="card-text">Use the menu to start</p>
    </div>
  </div>
</div>
</template>
<script>
export default {
  name: 'home'
}
</script>
